export function parseJson(target: any, propertyName: string, descriptor: PropertyDescriptor) {
  const originalMethod = descriptor.value

  descriptor.value = function (...args: any[]) {
    const parsedArgs = args.map((arg) => {
      if (typeof arg === 'string') {
        try {
          return JSON.parse(arg)
        } catch (error) {
          console.error('[parseJson]:An error occurred while parsing JSON:', error, originalMethod)

          return arg
        }
      } else {
        return arg
      }
    })

    return originalMethod.apply(this, parsedArgs)
  }

  return descriptor
}
